<template>
  <w-dialog :dialog-show="setPrivacyShow" @handleClose="handleClose">
    <div class="privacy-content" slot="content" @touchmove.prevent>
      <div class="privacy-header flex-between">
        <span>权限设置</span>
        <span v-if="privacyType === 'notSetPrivacy'" @click="setPrivacyShow = false" class="iconfont iconx"/>
      </div>
      <div v-if="privacyType === 'notSetPrivacy'">
        <p class="privacy-container">简历中缺失必填信息，无法设置为 HR 可见<br><span class="high-light">请检查后重新修改简历权限</span></p>
      </div>
      <div v-else>
        <p class="privacy-sub-title">只有一份可公开简历 ，请选择您的简历</p>
        <w-select :options="privacyOptions" :field="'cv_token'" :placeholder="'请选择您的简历'" :disabled="privacyDisabled"
                  @selectValue="changePriValue"/>
        <div class="extent-select">
          <div class="extent-item privacy-extent" v-for="item in extentSelectPrivacy" :key="item.id">
            <p v-if="item.id === 'in_private'" class="private-title">设置简历私密，即所有简历不可见</p>
            <div class="flex">
              <div class="flex extent-left">
                <input class="w-radio" type="radio" name="extent" :id="item.id" @change="changeRadio(item.id)"
                       :checked="item.checked">
                <label :for="item.id">{{item.label}}</label>
              </div>
              <label class="desc" :for="item.id">{{ item.description }}</label>
            </div>
          </div>
        </div>
      </div>
      <button class="theme-button flex-center" @click="setPrivacy">{{ privacyType === 'notSetPrivacy' ? '我知道了' :
        '确定'}}
      </button>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import WSelect from '@/components/global/w-select'

	export default {
		name: 'more-public-cv.vue',
		props: {
			cvsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			setPrivacyShow: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				privacyOptions: [],
				visibility: '',
				privacyType: '',
				extentSelectPrivacy: [
					{ id: 'hr_visible', label: 'HR 可见', description: '让 HR 看见你', checked: true },
					{ id: 'in_private', label: '私密', description: '仅自己可查看' },
				],
			}
		},
		mounted () {
			this.dealPrivacy()
		},
		computed: {
			privacyDisabled () {
				return this.visibility === 'in_private'
			}
		},
		watch: {},
		components: {
			WDialog,
			WSelect
		},
		methods: {
			handleClose () {
				if (this.privacyType === 'notSetPrivacy') this.$emit('handleClose')
			},
			async setPrivacy () {
				if (this.privacyType === 'selectPrivacy') {
					if (this.visibility === 'in_private') {
						let tokens = this.cvsData.has_multiple_public_cv.map(item => item.token).join()
						let res = await this._changeVisibility(undefined, { cv_tokens: tokens })
						if (res.status === 1) {
							this.$emit('refresh')
							this.$emit('handleClose')
						}
					} else {
						let tokens = this.cvsData.has_multiple_public_cv
							.filter(item => item.token !== this.cv_token)
							.map(v => v.token).join()
						let res = await this._changeVisibility(this.cv_token, { cv_tokens: tokens })
						if (res.status === 1) {
							this.$emit('refresh')
							this.$emit('handleClose')
						}
					}
				} else {
					this.$emit('handleClose')
				}
			},
			dealPrivacy () {
				if (this.cvsData.has_multiple_public_cv instanceof Array && !this.versionShow) {
					this.privacyType = 'selectPrivacy'
					this.visibility = 'hr_visible'
				} else if (this.cvsData.has_multiple_public_cv && !this.versionShow) {
					this.privacyType = 'notSetPrivacy'
				}
			},
			async _changeVisibility (token, obj) {
				return await this.$api.cv.updateCvVisibility({
					cv_token: token,
					visibility: this.cvBase.visibility,
					...obj
				})
			},
			changePriValue (item, field) {
				this[field] = item.value
			},
			// 简历私密度弹窗切换简历私密度
			changeRadio (val) {
				this.visibility = val
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .privacy-content {
    width: 90vw;
    border-radius: 10px;
    background-color: $color-light;
    padding: 32px 24px;
    .privacy-header {
      margin-bottom: 28px;
      span {
        font-size: $font-size-large;
        color: $color-title;
        font-weight: 500;
      }
      .iconfont {
        font-size: 18px;
        color: #8c8c8c;
        font-weight: bold;
      }
    }
    .privacy-container {
      line-height: 24px;
      margin-bottom: 48px;
      .high-light {
        color: $color-theme;
      }
    }
    .privacy-sub-title {
      margin-bottom: 12px;
      color: $color-dark-gray;
    }
    .w-select {
      margin-bottom: 14px;
    }
    button {
      width: 100%;
      height: 38px;
      border-radius: 2px;
      font-size: $font-size-medium;
    }
  }
  .extent-select {
    .extent-item {
      margin-bottom: 16px;
      .extent-left {
        width: 40%;
        label {
          color: $color-title;
        }
      }
      .desc {
        color: $color-light-gray;
        font-size: $font-size-medium;
      }
    }
    .privacy-extent {
      &:nth-child(2) {
        margin-bottom: 30px;
      }
      .private-title {
        color: $color-dark-gray;
        margin-bottom: 12px;
      }
    }
  }
</style>
